<script lang="ts" setup>
import type {BlogSectionBlock} from '~/types/legacy'
import type {WorkshopBlog} from '~/types/workshop'
import type {Populated} from '~/types/populated'

const props = defineProps<{
  data: Exclude<Populated<BlogSectionBlock> | Populated<WorkshopBlog>, undefined>
}>()

const style = 'h-40 w-40'
</script>

<template>
  <Container
    v-if="data"
    class="flex flex-col items-center space-y-8 border bg-white px-4 py-8 sm:px-6 sm:py-12 lg:space-y-32 lg:px-10 lg:py-16"
  >
    <div class="flex flex-col items-center text-center">
      <Heading size="caption" as="h2">
        {{ data.headline }}
      </Heading>
      <Heading class="w-full lg:w-2/3" as="h3" size="large">
        {{ data.title }}
      </Heading>
    </div>

    <div
      class="grid w-full grid-cols-1 gap-4 rounded-lg border border-gray-200 bg-white shadow-md md:grid-cols-2 lg:w-3/4 lg:grid-cols-3 lg:gap-8"
    >
      <ArticlePreview
        v-for="article in data.articles?.slice(0, 3)"
        :key="article.slug"
        :article="article"
        class="rounded-lg bg-white p-6"
      />
    </div>
  </Container>
</template>
